import _objectSpread from "@babel/runtime-corejs2/helpers/esm/objectSpread";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/esm/objectWithoutProperties";
import React from "react";
import * as types from "../../types";
import { getWidget, getUiOptions, isSelect, optionsList, getDefaultRegistry, hasWidget } from "../../utils";
function StringField(props) {
  var schema = props.schema,
    name = props.name,
    uiSchema = props.uiSchema,
    idSchema = props.idSchema,
    formData = props.formData,
    required = props.required,
    disabled = props.disabled,
    readonly = props.readonly,
    autofocus = props.autofocus,
    onChange = props.onChange,
    onBlur = props.onBlur,
    onFocus = props.onFocus,
    _props$registry = props.registry,
    registry = _props$registry === void 0 ? getDefaultRegistry() : _props$registry,
    rawErrors = props.rawErrors;
  var title = schema.title,
    format = schema.format;
  var widgets = registry.widgets,
    formContext = registry.formContext;
  var enumOptions = isSelect(schema) && optionsList(schema);
  var defaultWidget = enumOptions ? "select" : "text";
  if (format && hasWidget(schema, format, widgets)) {
    defaultWidget = format;
  }
  var _getUiOptions = getUiOptions(uiSchema),
    _getUiOptions$widget = _getUiOptions.widget,
    widget = _getUiOptions$widget === void 0 ? defaultWidget : _getUiOptions$widget,
    _getUiOptions$placeho = _getUiOptions.placeholder,
    placeholder = _getUiOptions$placeho === void 0 ? "" : _getUiOptions$placeho,
    options = _objectWithoutProperties(_getUiOptions, ["widget", "placeholder"]);
  var Widget = getWidget(schema, widget, widgets);
  return React.createElement(Widget, {
    options: _objectSpread({}, options, {
      enumOptions: enumOptions
    }),
    schema: schema,
    uiSchema: uiSchema,
    id: idSchema && idSchema.$id,
    label: title === undefined ? name : title,
    value: formData,
    onChange: onChange,
    onBlur: onBlur,
    onFocus: onFocus,
    required: required,
    disabled: disabled,
    readonly: readonly,
    formContext: formContext,
    autofocus: autofocus,
    registry: registry,
    placeholder: placeholder,
    rawErrors: rawErrors
  });
}
if (process.env.NODE_ENV !== "production") {}
StringField.defaultProps = {
  uiSchema: {},
  disabled: false,
  readonly: false,
  autofocus: false
};
export default StringField;